import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TrsTool',
    props: {
        trsTool: null
    },
    emits: ["onImport"],
    setup(__props, { emit }) {
        const props = __props;
        function importVersion(version) {
            const version_id = version.id.includes(`:${version.name}`) ? version.name : version.id;
            emit("onImport", version_id);
        }
        return { __sfc: true, props, emit, importVersion };
    }
});
